// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactForm_overlay__pnuHu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease, visibility 0s linear 0.3s;
}

.ContactForm_overlay__pnuHu.ContactForm_open__OOM5J {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transition: opacity 0.3s ease, visibility 0s linear 0s;
}

.ContactForm_modal__6qxsp {
  background: var(--color-background);
  padding: var(--space-lg);
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  transform: translateY(-50px);
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: 0;
}

.ContactForm_overlay__pnuHu.ContactForm_open__OOM5J .ContactForm_modal__6qxsp {
  transform: translateY(0);
  opacity: 1;
}

.ContactForm_closeButton__9y0le {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: var(--font-size-large);
  color: var(--color-text);
  cursor: pointer;
}

.ContactForm_modalContent__6yiLz {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.ContactForm_formContainer__85Lk4 {
  flex: 2 1;
  padding-right: var(--space-lg);
}

.ContactForm_infoContainer__WjPXY {
  flex: 1 1;
  padding-left: var(--space-lg);
  border-left: 1px solid var(--color-text-subtle);
}

.ContactForm_infoContainer__WjPXY h3 {
  margin-bottom: var(--space-sm);
}

.ContactForm_infoContainer__WjPXY p {
  margin: var(--space-xs) 0;
}

.ContactForm_socialLinks__PIca3 a {
  margin-right: var(--space-xs);
  color: var(--color-text);
  font-size: var(--font-size-large);
}

.ContactForm_formRow__M38\\+A {
  display: flex;
  justify-content: space-between;
}

.ContactForm_formGroup__WQ3fC {
  flex: 1 1;
  margin-bottom: var(--space-md); /* Ensure bottom margin */
}

.ContactForm_formGroup__WQ3fC:not(:last-child) {
  margin-right: var(--space-md);
}

.ContactForm_formGroup__WQ3fC label {
  display: block;
  margin-bottom: var(--space-xs);
  color: var(--color-text);
}

.ContactForm_formGroup__WQ3fC input,
.ContactForm_formGroup__WQ3fC textarea,
.ContactForm_formGroup__WQ3fC select {
  width: 100%;
  padding: var(--space-xs);
  font-size: var(--font-size-base);
  color: var(--color-text);
  background: #333;
  border: 1px solid #555;
  border-radius: 5px;
}

.ContactForm_formGroup__WQ3fC textarea {
  height: 100px;
  resize: vertical;
}

/* Center the send button */
.ContactForm_submitButton__XshIe {
  display: inline-block;
  padding: var(--space-xs) var(--space-sm);
  background-color: var(--color-text);
  color: var(--color-background);
  text-decoration: none;
  font-size: var(--font-size-small);
  border-radius: 25px;
  border: none;
  transition: transform 0.3s ease, background-color 0.3s ease;
  cursor: pointer;
  margin: var(--space-md) auto 0 auto; /* Center horizontally and add top margin */
  display: block; /* Ensure it's a block element for centering */
}

.ContactForm_submitButton__XshIe:hover {
  transform: scale(1.05);
  background-color: var(--color-text-subtle);
}

.ContactForm_legalText__3Z7lD {
  margin-top: var(--space-lg);
  font-size: var(--font-size-small);
  color: var(--color-text-subtle);
  line-height: 1.4;
  width: 100%; /* Ensure it fills the available space */
}

@media (max-width: 768px) {
  .ContactForm_modalContent__6yiLz {
    flex-direction: column;
  }
  .ContactForm_infoContainer__WjPXY {
    padding-left: 0;
    border-left: none;
    margin-bottom: var(--space-lg);
  }
  .ContactForm_formContainer__85Lk4 {
    padding-right: 0;
  }
  .ContactForm_formRow__M38\\+A {
    flex-direction: column;
  }
  .ContactForm_formGroup__WQ3fC {
    margin-right: 0;
    margin-bottom: var(--space-sm);
    width: 100%; /* Ensure full width */
  }
  .ContactForm_formGroup__WQ3fC input,
  .ContactForm_formGroup__WQ3fC textarea,
  .ContactForm_formGroup__WQ3fC select {
    width: 100%; /* Ensure full width */
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
  }
  .ContactForm_submitButton__XshIe {
    margin-top: var(--space-md);
    width: 100%; /* Make button full width on mobile */
    margin-bottom: var(--space-lg); /* Add bottom margin */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContactForm.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,8BAA8B,EAAE,yBAAyB;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;EACX,wBAAwB;EACxB,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,wCAAwC;EACxC,mCAAmC;EACnC,8BAA8B;EAC9B,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,2DAA2D;EAC3D,eAAe;EACf,mCAAmC,EAAE,2CAA2C;EAChF,cAAc,EAAE,8CAA8C;AAChE;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW,EAAE,wCAAwC;AACvD;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,8BAA8B;IAC9B,WAAW,EAAE,sBAAsB;EACrC;EACA;;;IAGE,WAAW,EAAE,sBAAsB;IACnC,sBAAsB,EAAE,uEAAuE;EACjG;EACA;IACE,2BAA2B;IAC3B,WAAW,EAAE,qCAAqC;IAClD,8BAA8B,EAAE,sBAAsB;EACxD;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.3s ease, visibility 0s linear 0.3s;\n}\n\n.overlay.open {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transition: opacity 0.3s ease, visibility 0s linear 0s;\n}\n\n.modal {\n  background: var(--color-background);\n  padding: var(--space-lg);\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  position: relative;\n  width: 90%;\n  max-width: 900px;\n  max-height: 90vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  transform: translateY(-50px);\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  opacity: 0;\n}\n\n.overlay.open .modal {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.closeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: var(--font-size-large);\n  color: var(--color-text);\n  cursor: pointer;\n}\n\n.modalContent {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.formContainer {\n  flex: 2;\n  padding-right: var(--space-lg);\n}\n\n.infoContainer {\n  flex: 1;\n  padding-left: var(--space-lg);\n  border-left: 1px solid var(--color-text-subtle);\n}\n\n.infoContainer h3 {\n  margin-bottom: var(--space-sm);\n}\n\n.infoContainer p {\n  margin: var(--space-xs) 0;\n}\n\n.socialLinks a {\n  margin-right: var(--space-xs);\n  color: var(--color-text);\n  font-size: var(--font-size-large);\n}\n\n.formRow {\n  display: flex;\n  justify-content: space-between;\n}\n\n.formGroup {\n  flex: 1;\n  margin-bottom: var(--space-md); /* Ensure bottom margin */\n}\n\n.formGroup:not(:last-child) {\n  margin-right: var(--space-md);\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: var(--space-xs);\n  color: var(--color-text);\n}\n\n.formGroup input,\n.formGroup textarea,\n.formGroup select {\n  width: 100%;\n  padding: var(--space-xs);\n  font-size: var(--font-size-base);\n  color: var(--color-text);\n  background: #333;\n  border: 1px solid #555;\n  border-radius: 5px;\n}\n\n.formGroup textarea {\n  height: 100px;\n  resize: vertical;\n}\n\n/* Center the send button */\n.submitButton {\n  display: inline-block;\n  padding: var(--space-xs) var(--space-sm);\n  background-color: var(--color-text);\n  color: var(--color-background);\n  text-decoration: none;\n  font-size: var(--font-size-small);\n  border-radius: 25px;\n  border: none;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n  cursor: pointer;\n  margin: var(--space-md) auto 0 auto; /* Center horizontally and add top margin */\n  display: block; /* Ensure it's a block element for centering */\n}\n\n.submitButton:hover {\n  transform: scale(1.05);\n  background-color: var(--color-text-subtle);\n}\n\n.legalText {\n  margin-top: var(--space-lg);\n  font-size: var(--font-size-small);\n  color: var(--color-text-subtle);\n  line-height: 1.4;\n  width: 100%; /* Ensure it fills the available space */\n}\n\n@media (max-width: 768px) {\n  .modalContent {\n    flex-direction: column;\n  }\n  .infoContainer {\n    padding-left: 0;\n    border-left: none;\n    margin-bottom: var(--space-lg);\n  }\n  .formContainer {\n    padding-right: 0;\n  }\n  .formRow {\n    flex-direction: column;\n  }\n  .formGroup {\n    margin-right: 0;\n    margin-bottom: var(--space-sm);\n    width: 100%; /* Ensure full width */\n  }\n  .formGroup input,\n  .formGroup textarea,\n  .formGroup select {\n    width: 100%; /* Ensure full width */\n    box-sizing: border-box; /* Include padding and border in the element's total width and height */\n  }\n  .submitButton {\n    margin-top: var(--space-md);\n    width: 100%; /* Make button full width on mobile */\n    margin-bottom: var(--space-lg); /* Add bottom margin */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `ContactForm_overlay__pnuHu`,
	"open": `ContactForm_open__OOM5J`,
	"modal": `ContactForm_modal__6qxsp`,
	"closeButton": `ContactForm_closeButton__9y0le`,
	"modalContent": `ContactForm_modalContent__6yiLz`,
	"formContainer": `ContactForm_formContainer__85Lk4`,
	"infoContainer": `ContactForm_infoContainer__WjPXY`,
	"socialLinks": `ContactForm_socialLinks__PIca3`,
	"formRow": `ContactForm_formRow__M38+A`,
	"formGroup": `ContactForm_formGroup__WQ3fC`,
	"submitButton": `ContactForm_submitButton__XshIe`,
	"legalText": `ContactForm_legalText__3Z7lD`
};
export default ___CSS_LOADER_EXPORT___;
